import classNames from 'classnames';
import { forwardRef, memo } from 'react';

import { Settings2Icon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

import { NEW_FILTERS_BUTTON } from '~/constants/testIDs';

export type FiltersButtonProps = {
  isActive: boolean;
  filtersCount?: number;
} & ButtonProps;

const _FiltersButton = forwardRef<HTMLButtonElement, FiltersButtonProps>(
  ({ filtersCount, isActive, ...props }: FiltersButtonProps, ref) => {
    const hasFilters = !!filtersCount;

    return (
      <Button
        appearance="ghost"
        color={isActive || hasFilters ? 'blue' : 'grey'}
        className={classNames(
          'px-2.5',
          isActive || hasFilters
            ? 'ads:bg-primary-subtle bg-blue-3 ads:hover:bg-primary-subtle hover:bg-blue-5 active:bg-blue-5 ads:active:bg-primary-subtle'
            : undefined,
        )}
        data-testid={NEW_FILTERS_BUTTON}
        ref={ref}
        size="medium"
        suffix={
          !!filtersCount && (
            <div
              className="flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-24 ads:bg-primary bg-blue-11 px-1 text-center font-bold ads:text-inverse text-10 text-blue-1"
              data-testid="NEW_FILTERS_BUTTON_COUNT"
            >
              {filtersCount}
            </div>
          )
        }
        {...props}
      >
        <Settings2Icon size="sm" />
      </Button>
    );
  },
);

_FiltersButton.displayName = '_FiltersButton';

export const FiltersButton = memo(_FiltersButton);

FiltersButton.displayName = 'FiltersButton';
